exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Updaters___ykaBk {\n  margin: 0 0 0.5rem;\n}\n\n.NoUpdaters___2ZO7w,\n.Updater___f5nQz,\n.UnmountedUpdater___2Smse {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  color: var(--color-text);\n}\n.Updater___f5nQz:focus,\n.Updater___f5nQz:hover {\n  outline: none;\n  background-color: var(--color-background-hover);\n}\n\n.NoUpdaters___2ZO7w,\n.UnmountedUpdater___2Smse {\n  color: var(--color-dim);\n}\n", ""]);

// exports
exports.locals = {
	"Updaters": "Updaters___ykaBk",
	"NoUpdaters": "NoUpdaters___2ZO7w",
	"Updater": "Updater___f5nQz",
	"UnmountedUpdater": "UnmountedUpdater___2Smse"
};